export default {
    //默认的一些组件属性
    pagination: {
        small: false,
        size: 20,
        pageSizes: [20, 50, 100, 200]
    },
    dialogBtnSize: 'small',
    formSize: 'small',
    formBtnSize: 'small',
    tableBtnSize: 'small',
    switchForm: {
        onColor: "#1CAF9A",
        offColor: "#bfcbd9"
    },
    breadcrumbs: '/',
    labelWidth: 80,
    elRowGutter: 10,
    tabMenu: []
}


// WEBPACK FOOTER //
// ./src/other/store/state.js